import React from 'react';
import BaseButton from '../Button/BaseButton';

// fullWidth: 부모(인풋) 폭에 맞춘다 — 채용공고 작성 폼처럼 좁은 칸 안에서 사용할 때
function TopikList({ onSelect, isMyPage, fullWidth = false }) {
  const options = [
    'TOPIK Level 1 (1급)',
    'TOPIK Level 2 (2급)',
    'TOPIK Level 3 (3급)',
    'TOPIK Level 4 (4급)',
    'TOPIK Level 5 (5급)',
    'TOPIK Level 6 (6급)',
  ];

  return (
    <div
      className={`${
        fullWidth
          ? 'w-full'
          : isMyPage
            ? 'min-w-[340px] md:min-w-[340px]'
            : 'min-w-[334px] md:min-w-[380px]'
      } bg-grayscale-gray00 border border-grayscale-gray02 
        rounded-[15px] p-2 shadow-popup-02`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <ul role='menu' className='list-none p-0 m-0'>
        {options.map((option) => (
          <li
            key={option}
            className='flex items-center rounded-lg transition-colors duration-150'
          >
            <BaseButton
              type='text'
              size='m'
              hideIcon
              bgclass='bg-grayscale-gray00'
              borderclass='border-none'
              textclass='justify-start'
              hoverclass='hover:bg-grayscale-gray01 hover:text-text-primary'
              activeclass='active:bg-grayscale-gray02 active:text-text-primary'
              width='100%'
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onSelect(option);
              }}
              leftalign='true'
            >
              {option}
            </BaseButton>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default TopikList;
